import React, { useState } from 'react';
import {
  Box,
  Flex,
  Input,
  Button,
  InputGroup,
  InputRightElement,
  Text,
} from '@chakra-ui/react';
import { FaSearch, FaFileAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
// import FilterBar from '../FilterBar/FilterBar';
import orcanaLogo from '../../assets/images/orcana_logo.png';

interface HeaderProps {
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ onLogout }) => {
  const [searchQuery, setSearchQuery] = useState<string>(''); // State for search input
  const navigate = useNavigate();

  const handleSearch = (): void => {
    console.log('Search query:', searchQuery);
    setSearchQuery('');
    navigate('/orcana-live');
  };

  const handleTabClick = (path: string): void => {
    navigate(path);
  };

  return (
    <Box>
      <Box
        as="header"
        w="100%"
        bg="white"
        boxShadow="sm"
        position="fixed"
        top="0"
        left="0"
        zIndex="1000"
        px={6}
        py={4}
      >
        <Flex align="center" justify="space-between">
          {/* Left: Logo */}
          <Flex
            align="center"
            cursor="pointer"
            gap={3}
          >
            <Box
              as="img"
              src={orcanaLogo}
              alt="Orcana Logo"
              boxSize="40px"
            />
            <Text fontSize="24px" fontWeight="bold" color="primary.500">
              Orcana.AI
            </Text>
          </Flex>

          {/* Center: Search Bar */}
          <Flex flex="1" justify="center" align="center">
            <InputGroup w="90%">
              <Input
                placeholder="Ask Orcana anything..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') handleSearch();
                }}
                bg="gray.100"
                borderRadius="full"
                border="1px solid"
                borderColor="gray.200"
                _focus={{
                  borderColor: 'transparent',
                  boxShadow: '0 0 0 3px rgba(55, 80, 120, 0.3)',
                }}
              />
              <InputRightElement>
                <Button
                  h="full"
                  size="sm"
                  borderRadius="full"
                  bg="gray.300"
                  _hover={{ bg: 'primary.500', color: 'white' }}
                  onClick={handleSearch}
                >
                  <FaSearch />
                </Button>
              </InputRightElement>
            </InputGroup>
          </Flex>

          {/* Right: Action Buttons */}
          <Flex gap={4} align="center">
            <Button
              leftIcon={<FaFileAlt />}
              variant="ghost"
              border="1px solid transparent"
              _hover={{ borderColor: 'gray.200', bg: 'gray.100' }}
              onClick={() => handleTabClick('/orcana-live')}
              width="200px"
            >
              Orcana Live
            </Button>
            {/* <Button
              leftIcon={<FaChartLine />}
              variant="ghost"
              border="1px solid transparent"
              _hover={{ borderColor: 'gray.200', bg: 'gray.100' }}
              onClick={() => handleTabClick('/recommendations')}
              width="200px"
            >
              Recommendations
            </Button>
            <Button
              leftIcon={<FaFileAlt />}
              variant="ghost"
              border="1px solid transparent"
              _hover={{ borderColor: 'gray.200', bg: 'gray.100' }}
              onClick={() => handleTabClick('/alerts')}
              width="200px"
            >
              Alerts
            </Button> */}
            {/* Logout Button */}
            <Button
              variant="solid"
              colorScheme="red"
              onClick={onLogout}
              width="100px"
            >
              Logout
            </Button>
          </Flex>
        </Flex>
      </Box>

      {/* Reserve space at the top so content isn't hidden behind the header */}
      <Box>
        <Box h="80px" />

        {/* Filter Bar area */}
        {/* <Box bg="white" borderBottom="1px" borderColor="gray.200">
          <FilterBar />
        </Box> */}
      </Box>
    </Box>
  );
};

export default Header;